/**
 * Constants for IrrigationPlanPage
 * Extracted from main component to improve maintainability
 */

/**
 * Default values for irrigation plan configuration
 */
export const IRRIGATION_DEFAULTS = {
  /** Default irrigation duration for a new step (in minutes) */
  DEFAULT_DURATION_MINUTES: 20,
  /** Default start time for irrigation plans */
  DEFAULT_START_TIME: "06:00",
  /** Number of seconds in a minute */
  SECONDS_PER_MINUTE: 60,
  /** Number of minutes in an hour */
  MINUTES_PER_HOUR: 60,
  /** Number of minutes in a day */
  MINUTES_PER_DAY: 24 * 60,
} as const;

/**
 * Time format string constants
 */
export const TIME_FORMAT = "HH:MM" as const;
export const DATE_FORMAT = "YYYY-MM-DD" as const;

/**
 * Temporary ID prefix for unsaved steps
 */
export const TEMP_STEP_ID_PREFIX = "step-";

/**
 * Validation error messages in Portuguese
 */
export const VALIDATION_MESSAGES = {
  NAME_REQUIRED: "Nome é obrigatório",
  START_TIME_REQUIRED: "Horário de início é obrigatório",
  DAYS_REQUIRED: "Selecione pelo menos um dia da semana",
  END_DATE_BEFORE_START: "Data final deve ser posterior ou igual à data inicial",
  NO_SECTORS_AVAILABLE: "Não há setores disponíveis para adicionar",
} as const;
